export default __webpack_public_path__ + "static/media/plus_blue.05e2d202.svg";